import Configuration from './Configuration/index.js'
import Jobs from './Jobs/index.js';

export const subTabsConfig = [
    {
        tab: 'configuration',
        component: Configuration,
        permission: true,
        translateName: 'wizard.config',
        icon: 'navigation/settings',
    },
    {
        tab: 'jobs',
        component: Jobs,
        permission: true,
        translateName: 'wizard.processing',
        icon: 'navigation/resource',
    },
];